define('core/modules/panelizr',["require", "jquery", "core/wfm/leadforms", "core/ef_plugins/panelizr"], function(require, $) {
    // panelizr links 
    console.log('panelizr');
    return {
        init: function() {
            $('.panelizr-link').
                panelizr();

            $('.panelizr-trigger').on('click', function(event) {
                event.preventDefault();
                var targetID = $(this).attr('href');
                var $targetLink = $(targetID);
                $targetLink.trigger("click");
            });
        }
    };
});
